// Shared city/state options for listing coversheet steps (same as AddDeal flow)
export const US_OBJ = {
  lat: 37.09024,
  lng: -95.712891,
  south_west: {
    lat: 25.82,
    lng: -124.39,
  },
  north_east: {
    lat: 49.38,
    lng: -66.94,
  },
  address: "United States",
  country: {
    long_name: "United States",
    short_name: "US",
    types: [
      "country",
      "political",
    ],
  },
}

export const LISTING_STATE_OPTIONS = [
  { value: "California", label: "California" },
  { value: "Washington", label: "Washington" },
  { value: "Georgia", label: "Georgia" },
  { value: "Texas", label: "Texas" },
  { value: "Florida", label: "Florida" },
  { value: "Colorado", label: "Colorado" },
  { value: "Oregon", label: "Oregon" },
  { value: "Arizona", label: "Arizona" },
]
